export default __webpack_public_path__ + "static/media/ic-search-black.461ad798.svg";